export default "__VITE_PUBLIC_ASSET__fdee40bf__"